module.exports = __webpack_public_path__ + "static/shoe-black-w-3f16e201661d0ba28157c9a5a545c2f7.png";